import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton
} from "@mui/material";
import React from "react";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import { ReactComponent as CloseIcon } from "Assets/Icons/Home/CloseIcon.svg";
import { useSelector } from "react-redux";


const Modal = ({ open, setOpen, title, modalBody }) => {
  const handleClose = () => {
    setOpen(false);
  };

  const { Translation } = useSelector((state) => ({
    Translation: state.Translation.translation?.Course || {},
  }));

  return (
    <Dialog fullWidth maxWidth={"lg"} open={open}>
      <DialogTitle>
        {title}
        {/* <IconButton onClick={() => handleClose()}>
          {" "}
          <PrimaryIcon
            icon={CloseIcon}
            color="white"
            height="14px"
            width="14px"
          />{" "}
        </IconButton>{" "} */}
      </DialogTitle>
      <DialogContent>
        {modalBody}
      </DialogContent>
      {/* <DialogActions align="center">
        <Button
          onClick={() => handleClose()}
          variant="outlined"
          color="secondary"
        >
          {Translation?.Okay}
        </Button>
      </DialogActions> */}
    </Dialog>
  );
};

export default Modal;
